function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g data-name="Group 2"><path data-name="Rectangle 2" fill="none" d="M0 0h24v24H0z" /><path data-name="Path 1" d="M14.3 0L9 12l5.3 12 1.593-.719L10.916 12 15.895.719z" fill="currentColor" /></g></svg>;
});